import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { AppRouter } from "@/app/AppRouter";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { QueryTrackingProvider } from "@/stores/QueryTrackingContext";
import { SessionProvider } from "@/stores/SessionContext";
import { ThemeProvider } from "@/stores/ThemeContext";

// Create a React Query client
const queryClient = new QueryClient({
  // By setting the default staleTime to `infinity`, queries will never be considered stale, and will only re-fetch when
  // the page is reloaded
  defaultOptions: { queries: { staleTime: Infinity } },
});

export function App() {
  return (
    <ErrorBoundary>
      <SessionProvider>
        <QueryTrackingProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <AppRouter />
              <ReactQueryDevtools initialIsOpen={false} />
            </ThemeProvider>
          </QueryClientProvider>
        </QueryTrackingProvider>
      </SessionProvider>
    </ErrorBoundary>
  );
}
